import axios, { AxiosError } from "axios";
import {
  HHandPeople,
  IndicatorOverview,
  IndicatorYear,
  Location,
  NeighbouringMunicipality,
  UserResource,
} from "../../interfaces/resource.interfaces";
import {
  RequestHHandPeopleSettings,
  RequestIndicatorMultipleYearsSettings,
  RequestIndicatorSettings,
  RequestNeighbouringMunicipalitiesSettings,
} from "../../interfaces/settings.interfaces";
import {
  FeatureCollection,
  IsochronePoi,
} from "../../interfaces/map.interfaces";

export default class DataHandler {
  constructor() {
    $("#datahandler").data("obj", this);
  }

  requestIndicator(settings: any, callback: any) {
    $.ajax({
      url: `/geom/indicator`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true }, // Include HTTP cookies
      success: callback,
    });
  }

  requestChangeIndicator(settings: any, callback: any) {
    $.ajax({
      url: `/geom/changeIndicator`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestIndicatorMultipleYears(
    settings: RequestIndicatorMultipleYearsSettings
  ): Promise<IndicatorYear[]> {
    const result = await axios.post<IndicatorYear[]>(
      `/geom/indicatorMultipleYears`,
      settings
    );
    return result.data;
  }

  async requestHHandPeople(
    settings: RequestHHandPeopleSettings
  ): Promise<HHandPeople[]> {
    const result = await axios.post<HHandPeople[]>(
      `/geom/requestHHandPeople`,
      settings
    );
    return result.data;
  }

  requestFilterMask(settings: any, callback: any) {
    $.ajax({
      url: `/misc/filtermask`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestIndicatorOverview(): Promise<IndicatorOverview> {
    const result = await axios.get<IndicatorOverview>(
      `/misc/indicatoroverview`
    );
    return result.data;
  }

  async requestAggregatedIndicators(
    settings: RequestIndicatorSettings
  ): Promise<FeatureCollection[]> {
    const result = await axios.post<FeatureCollection[]>(
      `/geom/aggregatedIndicators`,
      settings
    );
    return result.data;
  }

  requestMunicipalities(callback: any) {
    $.ajax({
      url: `/geom/municipalities`,
      type: "GET",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  requestTranslateLatLonToMunicipality(settings: any, callback: any) {
    $.ajax({
      url: `/geom/translateLatLonToMunicipality`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  requestCantons(callback: any) {
    $.ajax({
      url: `/geom/cantons`,
      type: "GET",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestAllLocations(): Promise<Location> {
    const result = await axios.get<Location>(`/geom/allLocations`);
    return result.data;
  }

  requestCantonsMunicipalities(settings: any, callback: any) {
    $.ajax({
      url: `/geom/cantonsMunicipalities`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  requestPoI(settings: any, callback: any) {
    $.ajax({
      url: `/geom/requestPoI`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestIsochronePoi(settings: any): Promise<{geojson:IsochronePoi}[]> {
    const response = await axios.post<{geojson:IsochronePoi}[]>(`/geom/requestIsochronePoi`, settings);
    return response.data;
  }

  requestIsochrone(settings: any, callback: any) {
    $.ajax({
      url: `/geom/isochrones`,
      type: "POST",
      data: {
        profile: "foot-walking",
        locations: [settings.p_locations],
        range: [settings.p_range],
        intersections: "false",
        interval: settings.p_range,
        range_type: "time",
      },
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  requestMultipleIsochrones(settings: any, callback: any) {
    $.ajax({
      url: `/geom/multipleIsochrones`,
      type: "POST",
      data: {
        profile: "foot-walking",
        locations: settings.p_locations,
        range: [settings.p_range],
        intersections: "false",
        interval: settings.p_range,
        range_type: "time",
      },
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  requestNumPeopleInIsochrone(settings: any, callback: any) {
    $.ajax({
      url: `/geom/numPeopleInIsochrone`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestNeighbouringMunicipalities(
    settings: RequestNeighbouringMunicipalitiesSettings
  ) {
    const result = await axios.post<NeighbouringMunicipality[]>(
      `/geom/requestNeighbouringMunicipalities`,
      settings
    );
    return result.data;
  }

  requestIsochroneUpToInterval(settings: any, callback: any) {
    console.log("CALLED");
    const rangeType = settings.p_metric === "sec" ? "time" : "distance";

    $.ajax({
      url: `/geom/isochronesUpToInterval`,
      type: "POST",
      data: {
        profile: settings.p_profile,
        locations: [settings.p_location],
        range: [settings.p_range],
        intersections: "false",
        interval: settings.p_range,
        range_type: rangeType,
      },
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  mergeIsochrones(settings: any, callback: any) {
    $.ajax({
      url: `/geom/mergeIsochrones`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  removeWaters(settings: any, callback: any) {
    console.log("CALLED");
    $.ajax({
      url: `/geom/removeWaters`,
      type: "POST",
      data: settings,
      dataType: "json",
      xhrFields: { withCredentials: true },
      success: callback,
    });
  }

  async requestUserResources(): Promise<{ data: UserResource }> {
    try {
      const response = await axios.get<{ data: UserResource }>(
        `/user/resources`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error: any) {
      console.log("Fail to fetch user resources, error details below:");
      console.error(error.response.data);
      throw Error(error.response.data);
    }
  }

  // @ts-ignore
  requestEconomicStructureBySection(settings, callback) {
    $.post("/geom/economicStructure", settings, "json").done((data) => {
      callback(data);
    });
  }
  // @ts-ignore
  requestEconomicStructureByYear(settings, callback) {
    $.post("/geom/economicStructureByYear", settings, "json").done((data) => {
      callback(data);
    });
  }
  // @ts-ignore
  requestEconomicStructureBySectionCanton(settings, callback) {
    $.post("/geom/economicStructureCanton", settings, "json").done((data) => {
      callback(data);
    });
  }
  // @ts-ignore
  requestEconomicStructureByYearCanton(settings, callback) {
    $.post("/geom/economicStructureByYearCanton", settings, "json").done((data) => {
      callback(data);
    });
  }
}
